import { render } from "./AssignUser.vue?vue&type=template&id=25317ed8&scoped=true&ts=true&lang=pug"
import script from "./AssignUser.vue?vue&type=script&lang=ts"
export * from "./AssignUser.vue?vue&type=script&lang=ts"

import "./AssignUser.vue?vue&type=style&index=0&id=25317ed8&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Sultan/CMS Admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25317ed8"]])

export default __exports__